import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course05 from "../../../course/course-05/course";
import lesson0522 from "../lesson-22/lesson";
import lesson0527 from "../lesson-27/lesson";
import lesson0528 from "../lesson-28/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "5e980140-9a83-4b5e-92b6-df9ccffad0d2",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0522),
    lesson: lesson0522,
  },
  {
    id: "0efb84e9-7486-4b7f-87f7-85bef790459c",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0527),
    lesson: lesson0527,
  },
  {
    id: "df6d73d2-003f-4afb-85f5-b7e9194de062",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0528),
    lesson: lesson0528,
  },
];

export default lessonLinks;
